// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GHEZ","option":"styles_option__lzA-e","selected":"styles_selected__1QlNg"};